import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { persistor, store } from './store';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { SnackbarProvider } from 'notistack';
import { SnackbarUtilsConfigurator } from './hooks/ToastCustom';
import { PersistGate } from 'redux-persist/integration/react';
import { AppThemeProvider } from './context/ThemeContext';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
    <AppThemeProvider>
    <BrowserRouter>
    <LocalizationProvider dateAdapter={AdapterMoment}>
    <SnackbarProvider maxSnack={10}>
    <SnackbarUtilsConfigurator/>
    <App />
    </SnackbarProvider>
    </LocalizationProvider>
    </BrowserRouter>
    </AppThemeProvider>
    </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
